import { HTTPMethod, request } from '../global/api/legacyApi'
import queryClient from '../queryClient'
import type { APIResponse } from '../sharedLegacy/utils/api.types'

type AudienceRealtimeInfoDTO = {
  realtime_url: string
  realtime_channel: string
  realtime_authorization: string
  timezone_offset: string
}

type AudienceRealtimeInfo = {
  realtimeUrl: string
  realtimeChannel: string
  realtimeAuthorization: string
}

const mapDTOToAudienceRealtimeInfo = (
  dto: AudienceRealtimeInfoDTO
): AudienceRealtimeInfo => {
  return {
    realtimeUrl: dto.realtime_url,
    realtimeChannel: dto.realtime_channel,
    realtimeAuthorization: dto.realtime_authorization,
  }
}

const audienceRealtimeInfoQuery = {
  queryKey: ['REALTIME_INFO', 'audience'],
  queryFn: async () => {
    const { data } = await request<APIResponse<AudienceRealtimeInfoDTO>>({
      url: '/api/2/audience/realtime',
      method: HTTPMethod.GET,
    })
    return mapDTOToAudienceRealtimeInfo(data)
  },
  staleTime: Infinity,
  cacheTime: Infinity,
}

const getAudienceRealtimeInfo = () =>
  queryClient.fetchQuery(audienceRealtimeInfoQuery)

export { getAudienceRealtimeInfo }
